export function determineCurrentBaseUrl()
{
	let current = window.location.href;
	current = current.split('?')[0];
	current = current.split('#')[0];
	const parts = current.split('/');
	let acceptedParts = [];
	for(let i = 0; i < parts.length; i++)
	{
		if(parts[i] === 'page')
			break;
		
		acceptedParts.push(parts[i]);
	}
	let string = acceptedParts.join('/');
	return string[string.length-1] !== '/' ? string+'/' : string;
}
